/**
 * Consent Form for Sedation — uses the admission consent template
 * with the same clauses as hospitalisation.
 */
import { SNOOTS_BG } from '@snootsvet/shared'

import { buildAdmissionConsentForm } from '@/frontend/features/printing/documents/consent/admission-template.form'
import { ADMISSION_CLAUSES } from '@/frontend/features/printing/documents/consent/hospitalisation-consent'

export const sedationConsent = buildAdmissionConsentForm({
  id: 'sedation-consent',
  label: 'Sedation Consent',
  title: 'CONSENT FORM FOR SEDATION',
  // Sedation procedures are carried out at the Bounds Green clinic.
  clinic: SNOOTS_BG,
  clauses: ADMISSION_CLAUSES,
})
